<template>
    <module-list-layout :createAction="createAction" :module="module">
        <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
            <moduleForm
                :bindingForView="true"
                :dataToBind="dataToBind"
                :edit-mode="editMode"
                :on-create-callback="afterCreate"
                :on-edit-callback="afterEdit"
                :profilesList="profilesList"
                v-if="dialogVisible"></moduleForm>
        </el-dialog>

        <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </module-list-layout>
</template>

<script>
    import Vue from 'vue'

    import actionsCell from './ag-grid/ActionsCell'
    import module from './../index.js'
    import {notify} from '@/system-services/notify.js'

    export default {
        components: {
            moduleForm: () => import('./../form/View'),
            moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
        },
        data() {
            return {
                module: {
                    ...module
                },
                profilesList: [],
                editMode: false,
                dialogVisible: false,
                rowsCounter: 0,
                dataToBind: null,
                rowToEdit: null,
                agGrid: {
                    pagination: true,
                    enableRtl: this.V_langIsRTL,
                    agGridStyle: 'width: 100%; height: 650px; padding: 0',
                    agGridClass: 'ag-theme-material',
                    gridOptions: {
                        suppressCellSelection: true,
                        onGridReady: function (params) {
                            params.api.sizeColumnsToFit()
                        }
                    },
                    columnDefs: [
                        {
                            autoHeight: true,
                            field: 'display_name',
                            headerName: this.$ml.get('name_of_the_user'),
                            headerClass: this.V_lang + '-lang-text'
                        },
                        {
                            autoHeight: true,
                            headerName: this.$ml.get('details'),
                            headerClass: this.V_lang + '-lang-text',
                            field: 'profile_caption'
                        },
                        {
                            width: 80,
                            headerName: this.$ml.get('actions'),
                            headerClass: this.V_lang + '-lang-text',
                            cellRendererFramework: Vue.extend(actionsCell),
                            cellRendererParams: {
                                props: {
                                    actionsHandler: this.actionsHandler
                                }
                            }
                        }
                    ],
                    rowData: []
                }
            };
        },
        beforeMount() {
            this.$store.dispatch(this.module.info.name + '-api/list').then(response => {
                this.agGrid.rowData = response;
                this.rowsCounter = response.length;
            })
        },
        methods: {
            refreshGrid() {
                this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
            },
            afterEdit(updatedData) {
                // getting a rowNode by index
                // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

                this.agGrid.rowData[this.rowToEdit] = updatedData;
                this.dialogVisible = false;
                this.refreshGrid();
            },
            afterCreate(newEntity) {
                this.agGrid.rowData.push(newEntity);
                this.dialogVisible = false;
                this.refreshGrid();
            },
            createAction(params) {
                this.dialogVisible = true;
                this.editMode = false;
                this.dataToBind = null;
                this.rowToEdit = null;
                // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
            },
            editAction(params) {
                this.dialogVisible = true;
                this.editMode = true;
                this.dataToBind = params.data;
                this.rowToEdit = params.rowIndex;
                // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
            },
            removeAction(params) {
                this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
                    this.agGrid.rowData.splice(params.rowIndex, 1);
                    this.refreshGrid();
                    this.rowsCounter -= 1;
                    notify({
                        type: 'success',
                        title: this.$ml.get('deleted'),
                    });
                })
            },
            actionsHandler(command, params) {
                this[command](params)
            }
        }
    }
</script>
